export default "__VITE_ASSET__JV0GCgGk__"